import React from 'react';
import { Container } from '@soluto-design/react';

import BlockTitleSmall, {
    BlockTitleSmallProps,
} from '../../molecules/BlockTitleSmall';

export interface BlockTitleSmallSectionProps extends BlockTitleSmallProps {}

export default function BlockTitleSmallSection({
    ...props
}: BlockTitleSmallSectionProps) {
    return (
        <section className="mt-xxl mb-xl">
            <Container className="row">
                <div className="col-span-full lg:col-span-6">
                    <BlockTitleSmall {...props} />
                </div>
            </Container>
        </section>
    );
}
